(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lingr-homepage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const navLink = event.target.closest('.lg-mobile-nav a');
  if (navLink) navLink.closest('details').open = false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lingr-kingsman-product"] && !Shopify.designMode) return;
  try {
    
function parseLingrPackItems(raw) {
  const entries = JSON.parse(raw);
  if (!Array.isArray(entries) || entries.length === 0) throw new Error('invalid_selection');
  const quantities = new Map();
  for (const entry of entries) {
    if (!entry || !Number.isSafeInteger(entry.id) || entry.id <= 0 || !Number.isSafeInteger(entry.quantity) || entry.quantity <= 0) {
      throw new Error('invalid_selection');
    }
    quantities.set(entry.id, (quantities.get(entry.id) || 0) + entry.quantity);
  }
  return Array.from(quantities, ([id, quantity]) => ({ id, quantity }));
}

if (!customElements.get('lingr-kingsman-product')) {
  class LingrKingsmanProduct extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      if (this.querySelector('form')) {
        this.initialize();
      } else {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }

    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      const listen = (element, type, callback) => element?.addEventListener(type, callback, { signal: this.controller.signal });
      const tabs = Array.from(this.querySelectorAll('[data-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-panel]'));
      let index = 0;
      const showPanel = (next, focus = false) => {
        if (!tabs.length) return;
        index = (next + tabs.length) % tabs.length;
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, i) => {
        listen(tab, 'click', () => showPanel(i));
        listen(tab, 'keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            showPanel(index + (event.key === 'ArrowRight' ? 1 : -1), true);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            showPanel(event.key === 'Home' ? 0 : tabs.length - 1, true);
          }
        });
      });
      listen(this.querySelector('[data-prev]'), 'click', () => showPanel(index - 1));
      listen(this.querySelector('[data-next]'), 'click', () => showPanel(index + 1));

      const productImageButtons = Array.from(this.querySelectorAll('[data-product-image]'));
      const mainProductImage = this.querySelector('.lk-photo-panel img');
      const selectProductImage = (button, focus = false) => {
        if (!button || !mainProductImage) return;
        showPanel(0);
        mainProductImage.src = button.dataset.imageSrc;
        if (button.dataset.imageSrcset) mainProductImage.srcset = button.dataset.imageSrcset;
        productImageButtons.forEach((imageButton) => {
          const active = imageButton === button;
          imageButton.classList.toggle('is-active', active);
          imageButton.setAttribute('aria-pressed', String(active));
        });
        if (focus) button.focus();
      };
      productImageButtons.forEach((button) => listen(button, 'click', () => selectProductImage(button)));

      const form = this.querySelector('.lk-purchase form');
      if (!form) return;
      const offers = Array.from(form.querySelectorAll('[data-offer-radio]'));
      const addButton = form.querySelector('[data-add]');
      const addLabel = form.querySelector('[data-button-label]');
      const total = form.querySelector('[data-total]');
      const quantity = form.querySelector('[data-quantity]');
      const error = form.querySelector('[data-error]');
      const launch = form.querySelector('[data-launch]');
      const sticky = this.querySelector('[data-sticky]');
      const stickyLink = this.querySelector('[data-sticky-link]');
      const stickyTotal = this.querySelector('[data-sticky-total]');
      const pendingLabel = this.dataset.pendingLabel;
      const discountCodes = Object.freeze({
        two: 'LINGR-B2G1',
        three: 'LINGR-B3G2'
      });
      const formatMoney = (cents) => {
        if (!Number.isFinite(cents) || cents <= 0) return pendingLabel;
        try {
          return new Intl.NumberFormat(this.dataset.locale || 'en-ZA', {
            style: 'currency',
            currency: this.dataset.currency || 'ZAR',
            currencyDisplay: 'symbol'
          }).format(cents / 100);
        } catch {
          return pendingLabel;
        }
      };
      let submitting = false;
      const selection = () => offers.find((option) => option.checked);
      const showError = (message) => {
        error.textContent = message;
        error.hidden = false;
      };
      const refreshSlot = (select) => {
        const option = select.selectedOptions[0];
        const slot = select.closest('[data-bundle-slot]');
        const image = slot?.querySelector('[data-slot-image]');
        if (image && option) {
          image.src = option.dataset.image || '';
          image.alt = option.dataset.name || '';
          image.hidden = !option.dataset.image;
        }
      };
      const offerState = (radio) => {
        const card = radio.closest('[data-bundle-offer]');
        const selects = Array.from(card.querySelectorAll('[data-scent-select]'));
        const chosen = selects.map((select) => select.selectedOptions[0]).filter(Boolean);
        const paidCount = Number(card.dataset.paidCount);
        const valid = chosen.length === selects.length && chosen.every((option) => option.dataset.ready === 'true');
        const items = chosen.map((option) => ({ id: Number(option.value), quantity: 1 }));
        const computedPaidTotal = chosen.slice(0, paidCount).reduce((sum, option) => sum + Number(option.dataset.price || 0), 0);
        const computedSaved = chosen.slice(paidCount).reduce((sum, option) => sum + Number(option.dataset.price || 0), 0);
        const paidTotal = Number(card.dataset.bundlePrice) || computedPaidTotal;
        const saved = Number(card.dataset.bundleSaved) || computedSaved;
        return {
          card,
          selects,
          valid,
          items,
          paidTotal,
          saved,
          displayPrice: card.dataset.bundleDisplay || formatMoney(paidTotal),
          displaySave: card.dataset.bundleSaveDisplay || (saved > 0 ? this.dataset.saveLabel + ' ' + formatMoney(saved) : '')
        };
      };
      const updateSelection = () => {
        const selected = selection();
        if (!selected) return;
        offers.forEach((offer) => {
          const state = offerState(offer);
          const price = offer.closest('[data-bundle-offer]').querySelector('[data-offer-price]');
          const save = offer.closest('[data-bundle-offer]').querySelector('[data-offer-save]');
          price.textContent = state.displayPrice;
          save.textContent = state.displaySave;
          save.hidden = !state.displaySave;
          state.card.classList.toggle('is-unavailable', !state.valid);
          state.selects.forEach(refreshSlot);
        });
        const state = offerState(selected);
        const selectedVariant = state.items[0];
        const ready = state.valid && state.paidTotal > 0;
        const activeCard = selected.closest('[data-bundle-offer]');
        const bundleDisplayPrices = { one: 'R 499.00', two: 'R 998.00', three: 'R 1,497.00' };
        const activePrice = bundleDisplayPrices[activeCard.dataset.offer] || activeCard.dataset.bundleDisplay || state.displayPrice;
        if (total) total.textContent = activePrice;
        if (selectedVariant) form.querySelector('input[name="id"]').value = selectedVariant.id;
        quantity.value = String(state.items.length || 1);
        addButton.disabled = submitting || !ready;
        addButton.setAttribute('aria-busy', String(submitting));
        addLabel.textContent = submitting ? this.dataset.addingLabel : ready ? this.dataset.addLabel : state.paidTotal > 0 ? this.dataset.unavailableLabel : pendingLabel;
        launch.hidden = ready;
        offers.forEach((offer) => {
          offer.disabled = submitting;
          offer.closest('[data-bundle-offer]').querySelectorAll('select').forEach((select) => { select.disabled = submitting; });
        });
        if (stickyLink) {
          stickyLink.textContent = ready ? this.dataset.chooseLabel : this.dataset.notifyLabel;
          stickyLink.href = ready ? '#' + form.parentElement.id : '#lingr-newsletter';
        }
        if (stickyTotal) stickyTotal.textContent = activePrice;
      };
      const refreshBundleTotals = () => {
        error.hidden = true;
        updateSelection();
      };
      offers.forEach((offer) => {
        listen(offer, 'change', refreshBundleTotals);
        listen(offer, 'input', refreshBundleTotals);
      });
      form.querySelectorAll('[data-scent-select]').forEach((select) => {
        listen(select, 'change', refreshBundleTotals);
        listen(select, 'input', refreshBundleTotals);
      });
      listen(form, 'change', (event) => {
        if (event.target.matches('[data-offer-radio], [data-scent-select]')) refreshBundleTotals();
      });
      listen(form, 'click', (event) => {
        const card = event.target.closest('[data-bundle-offer]');
        if (!card || event.target.closest('select') || event.target.matches('[data-offer-radio]')) return;
        const radio = card.querySelector('[data-offer-radio]');
        if (radio && !radio.checked) {
          radio.checked = true;
          refreshBundleTotals();
        }
      });
      listen(form, 'submit', async (event) => {
        event.preventDefault();
        if (submitting) return;
        const selected = selection();
        const state = selected ? offerState(selected) : null;
        if (!state || !state.valid || state.paidTotal <= 0) {
          showError(this.dataset.selectionError);
          return;
        }
        let items;
        try {
          items = parseLingrPackItems(JSON.stringify(state.items));
        } catch {
          showError(this.dataset.selectionError);
          return;
        }
        submitting = true;
        error.hidden = true;
        updateSelection();
        try {
          if (!window.LingrShopping) throw new Error(this.dataset.errorLabel);
          await window.LingrShopping.add(items, state.items.length > 1 ? state.card.dataset.offer : '');
          submitting = false;
          updateSelection();
        } catch (failure) {
          if (!this.isConnected) return;
          submitting = false;
          updateSelection();
          showError(failure instanceof Error && failure.message && !(failure instanceof TypeError) ? failure.message : this.dataset.errorLabel);
        }
      });

      // Enable purchasing only after the bundle submit handler is attached.
      updateSelection();

      if (sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
          }
        });
        this.observer.observe(addButton);
      }
    }
  }
  customElements.define('lingr-kingsman-product', LingrKingsmanProduct);
}

document.querySelectorAll('[data-lingr-creator-carousel]').forEach((carousel) => {
  if (carousel.dataset.creatorInitialized === 'true') return;
  carousel.dataset.creatorInitialized = 'true';
  const viewport = carousel.querySelector('[data-lingr-creator-viewport]');
  const track = carousel.querySelector('.lk-creator-carousel__track');
  const previous = carousel.querySelector('[data-lingr-creator-prev]');
  const next = carousel.querySelector('[data-lingr-creator-next]');
  if (!viewport || !track || !previous || !next) return;

  const scrollAmount = () => {
    const card = track.querySelector('.lk-creator-carousel__card');
    return (card?.getBoundingClientRect().width || viewport.clientWidth * 0.75) + 12;
  };
  const updateControls = () => {
    const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
    previous.disabled = viewport.scrollLeft <= 2;
    next.disabled = viewport.scrollLeft >= maxScroll;
  };

  previous.addEventListener('click', () => viewport.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
  next.addEventListener('click', () => viewport.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  viewport.addEventListener('scroll', updateControls, { passive: true });
  window.addEventListener('resize', updateControls);
  updateControls();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lingr-product"] && !Shopify.designMode) return;
  try {
    

function initLingrProducts(scope = document) {
  scope.querySelectorAll('[data-lingr-product]').forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-gallery-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-panel]'));
    let galleryIndex = 0;
    const showPanel = (index, focus = false) => {
      galleryIndex = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === galleryIndex)); tab.tabIndex = i === galleryIndex ? 0 : -1; });
      panels.forEach((panel, i) => { panel.hidden = i !== galleryIndex; });
      if (focus) tabs[galleryIndex].focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => showPanel(i));
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); showPanel(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1), true); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); showPanel(event.key === 'Home' ? 0 : tabs.length - 1, true); }
      });
    });
    root.querySelector('[data-gallery-prev]').addEventListener('click', () => showPanel(galleryIndex - 1));
    root.querySelector('[data-gallery-next]').addEventListener('click', () => showPanel(galleryIndex + 1));
    const form = root.querySelector('.lp-buybox form');
    if (!form) return;
    const options = Array.from(form.querySelectorAll('input[name="lingr_selection"]'));
    options.forEach((option) => { option.disabled = false; });
    const add = form.querySelector('[data-add-button]');
    const total = form.querySelector('[data-selection-total]');
    const error = form.querySelector('[data-cart-error]');
    const sticky = root.querySelector('[data-sticky-link]');
    const unavailableText = root.dataset.buttonUnavailable;
    const notifyText = root.dataset.notifyLabel;
    let submitting = false;
    const selection = () => options.find((option) => option.checked) || options[0];
    const updateSelection = () => {
      const selected = selection();
      if (!selected) return;
      const ready = selected.dataset.ready === 'true';
      const bundlePrices = { one: 'R499', two: 'R998', trio: 'R1497' };
      total.textContent = bundlePrices[selected.value] || selected.dataset.price;
      add.disabled = submitting || !ready;
      add.textContent = submitting ? root.dataset.addingLabel : ready ? root.dataset.addLabel : unavailableText;
      form.querySelector('[data-quantity]').value = selected.value === 'two' ? '2' : '1';
      sticky.textContent = ready ? root.dataset.addLabel : notifyText;
      sticky.href = ready ? '#' + form.parentElement.id : '#lingr-newsletter';
      error.hidden = true;
    };
    options.forEach((option) => option.addEventListener('change', updateSelection));
    form.querySelectorAll('label.lp-option').forEach((label) => label.addEventListener('click', () => window.requestAnimationFrame(updateSelection)));
    updateSelection();
    sticky.addEventListener('click', (event) => { if (selection()?.dataset.ready === 'true') { event.preventDefault(); form.requestSubmit(); } });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting) return;
      const selected = selection();
      if (!selected || selected.dataset.ready !== 'true') { error.textContent = root.dataset.unavailableLabel; error.hidden = false; return; }
      const items = JSON.parse(selected.dataset.items);
      if (!items.length || items.some((item) => !item.id || item.quantity < 1)) { error.textContent = root.dataset.unavailableLabel; error.hidden = false; return; }
      submitting = true;
      updateSelection();
      options.forEach((option) => { option.disabled = true; });
      try {
        const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.errorLabel);
        window.location.assign(root.dataset.cartUrl);
      } catch (failure) {
        submitting = false;
        options.forEach((option) => { option.disabled = false; });
        updateSelection();
        error.textContent = failure.message || root.dataset.errorLabel;
        error.hidden = false;
      }
    });
  });
}
initLingrProducts();
document.addEventListener('shopify:section:load', (event) => initLingrProducts(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
